import type { ComponentProps } from 'react';

import { cn } from './cn';

export default function CadenceVerticalBar({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div className={cn('flex h-6 w-6 shrink-0 flex-col items-center', className)} {...props}>
      <div className={cn('h-full w-0.5', 'bg-lynch-100 dark:bg-lynch-800')} />
    </div>
  );
}
